<script lang="ts">
	import { browser } from '$app/environment';
	import { getAuthStore } from '$lib/auth/store';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import * as m from '$paraglide/messages';

	let failed = $state(false);
	const userSession = getAuthStore();

	if (browser) {
		if (window.opener && userSession?.getSession()) {
			// logged in
			const gotoPage = new URLSearchParams(window.location.search).get('gotoPage');
			window.opener.postMessage({ login: true, gotoPage });
		} else {
			// error
			failed = true;
		}
	}
</script>

<div class="grid place-items-center h-full">
	<div class="flex flex-col gap-2">
		<div class="p-2">
			{failed ? m.login_callback__failure() : m.login_callback__success()}
		</div>
		<Button
			variant="outline"
			onclick={() => window.close()}
			icon="close"
			text={m.login_callback__close_button()}
		/>
	</div>
</div>
